export default __webpack_public_path__ + "static/media/Ochurchill.6105e3ec.png";